import React, { useState } from 'react';
import './PlanejamentoAulas.css';

const PlanejamentoAulas = () => {
  const [selectedWeek, setSelectedWeek] = useState('current');
  const [selectedSubject, setSelectedSubject] = useState('all');

  const weeks = [
    { id: 'current', label: 'Semana Atual', dates: '03/02 - 07/02/2026' },
    { id: 'next', label: 'Próxima Semana', dates: '10/02 - 14/02/2026' },
    { id: 'previous', label: 'Semana Anterior', dates: '27/01 - 31/01/2026' }
  ];

  const subjects = [
    { id: 'all', label: 'Todas as Disciplinas', color: '#6366f1' },
    { id: 'matematica', label: 'Matemática', color: '#10b981' },
    { id: 'portugues', label: 'Português', color: '#f59e0b' },
    { id: 'historia', label: 'História', color: '#ef4444' },
    { id: 'ciencias', label: 'Ciências', color: '#8b5cf6' }
  ];

  const lessons = [
    {
      id: 1,
      day: 'Segunda-feira',
      date: '03/02/2026',
      subject: 'Matemática',
      topic: 'Equações de 2º Grau',
      time: '07:00 - 08:40',
      turma: '9º ano A',
      objectives: [
        'Identificar coeficientes de equações quadráticas',
        'Aplicar fórmula de Bhaskara',
        'Resolver problemas práticos'
      ],
      materials: ['Quadro branco', 'Calculadoras', 'Folha de exercícios'],
      activities: [
        'Revisão de equações do 1º grau (15min)',
        'Introdução ao conceito (20min)',
        'Exercícios práticos (40min)',
        'Correção e discussão (25min)'
      ],
      assessment: 'Observação participativa e exercícios avaliativos'
    },
    {
      id: 2,
      day: 'Terça-feira',
      date: '04/02/2026',
      subject: 'Português',
      topic: 'Análise de Textos Argumentativos',
      time: '08:50 - 10:30',
      turma: '9º ano A',
      objectives: [
        'Identificar estrutura argumentativa',
        'Reconhecer teses e argumentos',
        'Produzir texto dissertativo'
      ],
      materials: ['Textos impressos', 'Dicionários', 'Projetor'],
      activities: [
        'Leitura e análise de texto (25min)',
        'Identificação de elementos (30min)',
        'Produção textual (35min)',
        'Socialização dos trabalhos (10min)'
      ],
      assessment: 'Produção textual e participação em discussões'
    },
    {
      id: 3,
      day: 'Quarta-feira',
      date: '05/02/2026',
      subject: 'História',
      topic: 'Revolução Industrial',
      time: '07:00 - 08:40',
      turma: '9º ano B',
      objectives: [
        'Compreender contexto histórico',
        'Analisar consequências sociais',
        'Relacionar com atualidade'
      ],
      materials: ['Mapas históricos', 'Imagens', 'Vídeo documentário'],
      activities: [
        'Aula expositiva dialogada (30min)',
        'Análise de imagens (20min)',
        'Debate em grupos (30min)',
        'Síntese individual (10min)'
      ],
      assessment: 'Participação no debate e trabalho de síntese'
    },
    {
      id: 4,
      day: 'Quinta-feira',
      date: '06/02/2026',
      subject: 'Ciências',
      topic: 'Sistema Digestório Humano',
      time: '10:40 - 12:20',
      turma: '9º ano A',
      objectives: [
        'Identificar órgãos do sistema digestório',
        'Compreender processo digestivo',
        'Relacionar alimentação e saúde'
      ],
      materials: ['Modelo anatômico', 'Lâminas', 'Computador'],
      activities: [
        'Apresentação com modelo (25min)',
        'Pesquisa em grupos (30min)',
        'Apresentação dos grupos (25min)',
        'Quiz avaliativo (20min)'
      ],
      assessment: 'Quiz e apresentação em grupo'
    },
    {
      id: 5,
      day: 'Sexta-feira',
      date: '07/02/2026',
      subject: 'Matemática',
      topic: 'Revisão Semanal',
      time: '07:00 - 08:40',
      turma: '9º ano B',
      objectives: [
        'Consolidar conteúdos da semana',
        'Identificar dúvidas remanescentes',
        'Preparar para avaliação'
      ],
      materials: ['Lista de exercícios', 'Jogo educativo'],
      activities: [
        'Revisão dos tópicos (20min)',
        'Jogo de revisão em equipes (40min)',
        'Correção e feedback (30min)',
        'Planejamento da próxima semana (10min)'
      ],
      assessment: 'Participação no jogo e autoavaliação'
    }
  ];

  const filteredLessons = lessons.filter(lesson => 
    selectedSubject === 'all' || lesson.subject.toLowerCase().includes(selectedSubject.toLowerCase())
  );

  const getSubjectColor = (subject) => {
    const found = subjects.find(s => s.label === subject);
    return found ? found.color : '#6366f1';
  };

  return (
    <div className="planejamento-container">
      <div className="planejamento-header">
        <h2>📚 Planejamento de Aulas</h2>
        <p>Organize e planeje suas aulas semanalmente</p>
      </div>

      <div className="controls-section">
        <div className="week-selector">
          <label>Selecione a Semana:</label>
          <div className="week-buttons">
            {weeks.map(week => (
              <button
                key={week.id}
                className={`week-btn ${selectedWeek === week.id ? 'active' : ''}`}
                onClick={() => setSelectedWeek(week.id)}
              >
                <span className="week-label">{week.label}</span>
                <span className="week-dates">{week.dates}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="subject-filter">
          <label>Filtrar por Disciplina:</label>
          <select 
            value={selectedSubject} 
            onChange={(e) => setSelectedSubject(e.target.value)}
            className="subject-select"
          >
            {subjects.map(subject => (
              <option key={subject.id} value={subject.id}>
                {subject.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="lessons-grid">
        {filteredLessons.map(lesson => (
          <div key={lesson.id} className="lesson-card">
            <div className="lesson-header" style={{ borderLeftColor: getSubjectColor(lesson.subject) }}>
              <div className="lesson-day-info">
                <h3>{lesson.day}</h3>
                <span className="lesson-date">{lesson.date}</span>
              </div>
              <div className="lesson-subject">
                <span className="subject-badge" style={{ backgroundColor: getSubjectColor(lesson.subject) }}>
                  {lesson.subject}
                </span>
                <span className="lesson-time">⏰ {lesson.time}</span>
              </div>
            </div>

            <div className="lesson-content">
              <div className="lesson-topic">
                <h4>📖 {lesson.topic}</h4>
                <span className="turma-info">👥 {lesson.turma}</span>
              </div>

              <div className="lesson-section">
                <h5>🎯 Objetivos de Aprendizagem</h5>
                <ul>
                  {lesson.objectives.map((obj, index) => (
                    <li key={index}>{obj}</li>
                  ))}
                </ul>
              </div>

              <div className="lesson-section">
                <h5>📋 Materiais Necessários</h5>
                <div className="materials-list">
                  {lesson.materials.map((material, index) => (
                    <span key={index} className="material-tag">{material}</span>
                  ))}
                </div>
              </div>

              <div className="lesson-section">
                <h5>⏰ Atividades Planejadas</h5>
                <div className="activities-timeline">
                  {lesson.activities.map((activity, index) => (
                    <div key={index} className="activity-item">
                      <span className="activity-time">{activity.split('(')[1]?.replace(')', '')}</span>
                      <span className="activity-desc">{activity.split('(')[0].trim()}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="lesson-section">
                <h5>📊 Avaliação</h5>
                <p>{lesson.assessment}</p>
              </div>

              <div className="lesson-actions">
                <button className="action-btn edit-btn">
                  ✏️ Editar Aula
                </button>
                <button className="action-btn duplicate-btn">
                  📋 Duplicar
                </button>
                <button className="action-btn print-btn">
                  🖨️ Imprimir
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="summary-section">
        <div className="summary-card">
          <h3>📈 Resumo da Semana</h3>
          <div className="summary-stats">
            <div className="stat">
              <span className="stat-number">{filteredLessons.length}</span>
              <span className="stat-label">Aulas Planejadas</span>
            </div>
            <div className="stat">
              <span className="stat-number">{new Set(filteredLessons.map(l => l.subject)).size}</span>
              <span className="stat-label">Disciplinas</span>
            </div>
            <div className="stat">
              <span className="stat-number">{new Set(filteredLessons.map(l => l.turma)).size}</span>
              <span className="stat-label">Turmas</span>
            </div>
            <div className="stat">
              <span className="stat-number">25h</span>
              <span className="stat-label">Carga Horária</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanejamentoAulas;
